export default {
  install (Vue, store) {
    Vue.prototype.$sse = {
      role: null,
      token: null,
      connection: null
    }

    Vue.prototype.$sse.connect = function () {
      if (!window.EventSource) {
        throw new Error('this browser does not support SSE.')
      }

      this.connection = new EventSource((process.env.VUE_APP_API || window.location.origin) +
        '/engine/events/?role=' + this.role + '&token=' + this.token)

      this.connection.addEventListener('application', (ev) => store.commit('application', JSON.parse(ev.data)))
      this.connection.addEventListener('build', (ev) => store.commit('build', JSON.parse(ev.data)))
      this.connection.addEventListener('domain', (ev) => store.commit('domain', JSON.parse(ev.data)))
      this.connection.addEventListener('instance', (ev) => store.commit('instance', JSON.parse(ev.data)))
      this.connection.addEventListener('repository', (ev) => store.commit('repository', JSON.parse(ev.data)))
      this.connection.addEventListener('task', (ev) => store.commit('task', JSON.parse(ev.data)))

      return this.connection
    }

    Vue.prototype.$sse.channel = function (channel) {
      if (!window.EventSource) {
        throw new Error('this browser does not support SSE.')
      }

      return new EventSource((process.env.VUE_APP_API || window.location.origin) +
        '/engine/events/' + channel + '/?role=' + this.role + '&token=' + this.token)
    }

    Vue.prototype.$sse.close = function () {
      if (this.connection) {
        this.connection.close()
      }
      this.connection = null
    }
  }
}
